import React from 'react';
import { Box, Spacing, Text, Badge } from '@reservamos/elements';
import { Trans, useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import LocalizedCurrency from 'components/LocalizedCurrency';
import AddPointsButton from '../AddPointsButton';

/**
 * NotPointsContent component displays a message when there are no points
 * and optionally shows an add points button.
 */
const NotPointsContent = ({
  notPointsMessage,
  showAddPointsButton,
  rechargeURL,
  enableFundWidget,
  handleOpenFundWidget,
  handleUpdateWallet,
}) => {
  const { t } = useTranslation('payment');
  return (
    <Box paddingVertical="S" paddingHorizontal="S">
      <Spacing vertical>
        <Text textAlign="center" size="S">
          <Trans t={t} i18nKey={notPointsMessage} components={[<strong />]} />
        </Text>
        <Spacing justifyContent="center" alignItems="center" size="S">
          <Text size="S">{t('label.balance_intro')}</Text>
          <Badge roundCorners type="gray">
            <LocalizedCurrency price={0} weight="bold" decimals={2} />
          </Badge>
          <Text size="S">{t('label.balance_outro')}</Text>
        </Spacing>
        {showAddPointsButton && (
          <div>
            <AddPointsButton
              rechargeURL={rechargeURL}
              tooltipPosition="left"
              enableFundWidget={enableFundWidget}
              handleUpdateWallet={handleUpdateWallet}
              handleOpenFundWidget={handleOpenFundWidget}
            />
          </div>
        )}
      </Spacing>
    </Box>
  );
};

NotPointsContent.propTypes = {
  notPointsMessage: PropTypes.string,
  showAddPointsButton: PropTypes.bool,
  rechargeURL: PropTypes.string,
  enableFundWidget: PropTypes.bool,
  handleOpenFundWidget: PropTypes.func,
  handleUpdateWallet: PropTypes.func,
};

export default NotPointsContent;
